<template lang="pug">
  footer.footer(v-bind:class="{'is-warning': isHom}")
    .container
      .content.has-text-centered
        p(v-if="isHom").hom-warning SERVIDOR DE HOMOLOGAÇÃO
        p #[a(href="//www.THEPES.com.br" target="_BLANK") THEPES]. Sistema Empresarial ERP, {{year}}.
        p
          small Versão #[strong {{version}}]
</template>

<script>
  import {version} from '../../package.json'

  export default {
    name: 'custom-footer',
    data () {
      return {
        year: this.$moment().format('YYYY'),
        isHom: !!(process.env.IS_HOM),
        version: version
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "~@/assets/sass/common.sass"
  .footer
    padding: 2rem 1.5rem
    background: $primary
    color: white
    strong, a
      color: $warning
    &.is-warning
      background: $warning
    .hom-warning
      font-weight: bold
</style>



// WEBPACK FOOTER //
// Footer.vue?78334428